<form [formGroup]="invoiceFilterForm" (keydown.enter)="onEnterKey($event)">
	<div class="row">
		<mat-form-field appearance="outline" class="col-4">
			<mat-label>Termin płatności</mat-label>
			<mat-date-range-input [rangePicker]="paymentDeadlinePicker">
				<input matStartDate formControlName="paymentDeadlineFrom" placeholder="Od" />
				<input matEndDate formControlName="paymentDeadlineTo" placeholder="Do" />
			</mat-date-range-input>
			<mat-hint>DD.MM.YYYY – DD.MM.YYYY</mat-hint>
			<mat-datepicker-toggle matIconSuffix [for]="paymentDeadlinePicker"></mat-datepicker-toggle>
			<mat-date-range-picker #paymentDeadlinePicker></mat-date-range-picker>
		</mat-form-field>

		<div class="col-4">
			<app-generic-mat-autocomplete
				[apiUrl]="contractorsApiUrl"
				[apiSearchParam]="'isOskar=false&search'"
				[placeholder]="'Kontrahent'"
				[idKey]="'id'"
				[displayKeys]="['shortName']"
				[responseMapper]="contractorsResponseMapper"
				(selected)="invoiceFilterForm.patchValue({ contractorId: $event?.id ?? null })"
			></app-generic-mat-autocomplete>
		</div>

		<mat-form-field appearance="outline" class="col-4">
			<mat-label>Numer faktury</mat-label>
			<input matInput formControlName="number" />
		</mat-form-field>
	</div>

	<div class="row">
		<mat-form-field appearance="outline" class="col-3"
			><mat-label>NIP</mat-label>
			<input matInput formControlName="nip" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="col-3">
			<mat-label>Status</mat-label>
			<mat-select formControlName="status">
				<mat-option [value]="null"></mat-option>
				@for (status of statusVindicationFilters; track status.value) {
					<mat-option [value]="status.value">{{ status.label }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="col-3">
			<mat-label>Navigator ID</mat-label>
			<input type="number" matInput formControlName="navigatorId" />
		</mat-form-field>

		<div class="col-3">
			<app-generic-mat-autocomplete
				[apiUrl]="contractorsApiUrl"
				[apiSearchParam]="'isOskar=true&search'"
				[placeholder]="'Sprzedawca'"
				[idKey]="'id'"
				[displayKeys]="['shortName']"
				[responseMapper]="contractorsResponseMapper"
				(selected)="invoiceFilterForm.patchValue({ ourCompany: $event?.id ?? null })"
			></app-generic-mat-autocomplete>
		</div>
	</div>

	<div class="row">
		<mat-form-field appearance="outline" class="col-2">
			<mat-label>Dni po terminie min</mat-label>
			<input matInput type="number" formControlName="daysAfterDeadlineMin" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="col-2">
			<mat-label>Dni po terminie max</mat-label>
			<input matInput type="number" formControlName="daysAfterDeadlineMax" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="col-4">
			<mat-label>Referencja przewoźnika</mat-label>
			<input matInput type="text" formControlName="carrierReference" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="col-2">
			<mat-label>Dni odroczenia min</mat-label>
			<input matInput type="number" formControlName="deferredPaymentDaysMin" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="col-2">
			<mat-label>Dni odroczenia max</mat-label>
			<input matInput type="number" formControlName="deferredPaymentDaysMax" />
		</mat-form-field>
	</div>

	<div class="row justify-content-end">
		<div class="col-2 d-flex justify-content-end">
			<button class="me-2" mat-raised-button (click)="resetFilters()">Wyczyść</button>
			<button mat-raised-button color="primary" (click)="showInvoiceFilters()">Pokaż</button>
		</div>
	</div>
</form>
